import { Controller, useFormContext } from 'react-hook-form';

import { DateTimeInput } from '@ui/components/DateTimeInput';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

import { NewsPost } from '@features/shared/api/typings';

export function PublicationDateInput() {
  const { control } = useFormContext<NewsPost>();

  return (
    <FormRow>
      <FormLabel>Дата публикации</FormLabel>
      <FormInput>
        <Controller
          name="publishTimestampMs"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <DateTimeInput
              value={new Date(value)}
              onChange={(newDate) => onChange(newDate?.getTime())}
              disabled={disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
